<template>
    <div class="advertise" v-on:click="jumpToUrl">
        <img :src="imgUrl" v-if="imgUrl != ''"/>
        <div v-else class="stand">
            <img src="./images/ad.png" class="state-img">
        </div>

    </div>
</template>
<script>
    import $ from "jquery";
export default {
    props:{
        imgUrl:{
            type: String,
            default: ''
        },
        adUrl:{
            type: String,
            default: ''
        }
    },
    data: function() {
        return {

        }
    },
    methods: {
        jumpToUrl: function() {
            if (this.adUrl != '') {
                window.open(this.adUrl);
            } else {
                window.open('http://www.forex.com.cn');
            }
        }
    },
    mounted:function(){
        $(".stand").css({
            'line-height':$(".advertise").height() + "px"
        })
    }
}
</script>
<style lang="scss" scoped>
    .advertise{
        width: 100%;
        height: 100%;
        cursor: pointer;
        .stand{
            height: 100%;
            background: #D8D8D8;
            text-align: center;
            .state-img{
                display: inline-block;
                vertical-align: middle;
                width: 150px;
                height: 40px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/ad/advertise.vue